import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import ImageOverlayImageV2 from './ImageOverlayImageV2'
import gsap from 'gsap';
import { mobileIs, loadScrollMagic, getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";

const ImageOverlayV2 = ({ rendering, fields }) => {
	const { list, m_list, hide_shadow } = fields;
	const rootEl = useRef();
	const isMobile = mobileIs();
	const hideShadow = hide_shadow?.value;
	let listData = isMobile && m_list?.length ? m_list : list;
	let ScrollMagic = null;

	useEffect(() => {
		ScrollMagic = loadScrollMagic();
		const controller = new ScrollMagic.Controller();
		const scenes = [];

		if (rootEl.current) {
			const animItems = rootEl.current.querySelectorAll('.image img');

			animItems.forEach((item, index) => {
				gsap.set(item, {scale: 1.2});

				const tween = gsap.to(item, {
					scale: 1,
					duration: 0.8,
					ease: "power1.out"
				});

				const scene = new ScrollMagic.Scene({
					triggerElement: item.parentNode,
					triggerHook: 0.8,
					reverse: true
				})
				.setTween(tween)
				.addTo(controller);

				scenes.push(scene)
			});
		}

		// clean up
		return () => {
			scenes.forEach(scene => scene.destroy(true));
			controller.destroy(true);
		};
	}, []);



	const rootClasses = classNames("image-overlay-v2", getOverallSettingsClasses(fields));

	return (
		<div className={rootClasses} datasourceid={rendering.dataSource} ref={rootEl}>
			<div className="image-overlay-v2__body q-container" >
				<div className={classNames("image-overlay-v2__list", hideShadow ? "hide-shadow" : "")}>
					{
						listData.length > 0 &&
						listData.map((item, index) => {
							return <ImageOverlayImageV2 item={item} index={index} key={index} />
						}
						)
					}
				</div>
			</div>
		</div> 
	)
};
export default ImageOverlayV2;
